module.exports = __webpack_public_path__ + "static/img/5.abcca90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/5.jpg
// module id = tre5
// module chunks = 1